import { render, staticRenderFns } from "./livestockAdditionToUnit.vue?vue&type=template&id=de1f53dc&scoped=true&"
import script from "./livestockAdditionToUnit.vue?vue&type=script&lang=js&"
export * from "./livestockAdditionToUnit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de1f53dc",
  null
  
)

export default component.exports